/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const cardDetailsDataSchema = z.object({
	id: z.string(),
	brand: z.string(),
	last4: z.string(),
	expMonth: z.number(),
	expYear: z.number(),
})

export type CardDetailsDataSchema = z.infer<typeof cardDetailsDataSchema>
